<template>
  <card
    :bg="bg"
    class="o-card-thumbnail"
    :class="`o-card-video--${bg}`"
    modifier="thumbnail"
    :parallax="true"
  >
    <template #inner>
      <asset class="o-card-thumbnail__inner__img" :image="image" />
    </template>
    <template #behind> </template>
  </card>
</template>

<script>
import Asset from "objects/Asset";
import Card from "components/Card";
export default {
  components: {
    Asset,
    Card
  },
  props: {
    bg: {
      type: String,
      required: false,
      default: "bright"
    },
    image: {
      type: Object,
      required: false,
      default: null
    }
  }
};
</script>

<style lang="scss">
.o-card-thumbnail {
  display: flex;

  &--bright {
    color: $color-dark;
  }
}
</style>
